import { createAsyncThunk } from "@reduxjs/toolkit";
import { POST_RESET_PASSWORD } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import axios from "axios";
import { toast } from "../../components/app-toast";
import {
  getLocalizedMessage,
  getLocalizedErrorMessage,
} from "../../utils/messageHelper";
import i18n from "../../i18n";

export const postResetPassword = createAsyncThunk(
  POST_RESET_PASSWORD.post_reset_password,
  async (payload) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + APP_PATH.resetPassword,
        payload,
      );
      console.log("forgot password response:", response);
      if (response.data.status === 200) {
        const message = getLocalizedMessage(response, i18n);
        toast.success(message || response.data.response);
      } else if (response.data.status === 500) {
        const message = getLocalizedErrorMessage({ response }, i18n);
        if (response.data.message.non_field_errors) {
          toast.error(message || response.data.message.non_field_errors[0]);
        } else if (response.data.message.email) {
          toast.error(message || response.data.message.email[0]);
        } else if (response.data.message.otp) {
          toast.error(message || response.data.message.otp[0]);
        } else {
          toast.error(message);
        }
      }
      return response.data;
    } catch (error) {
      console.error("Error occurred during password reset:", error);
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message || i18n.t("toast.somethingWentWrong"));
      throw error; // Re-throw the error to let Redux Toolkit know that the operation failed
    }
  },
);
